module.exports = __webpack_public_path__ + "img/gacha1.8927c7a2.png";